import React from 'react';

function Contact() {
  const contactDetails = {
    name: "Michael Klesel",
    title: "Professor für Wirtschaftsinformatik",
    university: "Frankfurt University of Applied Sciences",
    department: "Fachbereich 3: Wirtschaft und Recht",
    address: {
      street: "Nibelungenplatz 1",
      city: "60318 Frankfurt am Main",
      country: "Germany"
    },
    // Email and LinkedIn removed as per the simplified data
  };

  // Optional: Style for the main page container.
  // Removed backgroundColor to allow dark theme to apply.
  const pageContainerStyle = {
    paddingTop: '3rem',
    paddingBottom: '3rem',
    // backgroundColor: '#f8f9fa' // Removed this line
  };

  return (
    <div className="container" style={pageContainerStyle}>
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          
          {/* Main Contact Info Card */}
          {/* The card styling (bg, color, border) should be handled by your dark.scss
              when body.dark-theme is active, via --bs-card-bg, etc. */}
          <div className="card shadow-sm">
            <div className="card-body p-4 p-md-5">

              {/* Personal Info Header in Card */}
              {/* Text colors (h2, p) should inherit from --bs-card-color or general text color variables */}
              <div className="text-center mb-4 pb-3 border-bottom"> {/* border-bottom will use --border-color */}
                <h2 className="h3 fw-semibold mb-1">{contactDetails.name}</h2>
                {/* text-primary should use your --link-color */}
                <p className="text-primary mb-0">{contactDetails.title}</p> 
                {/* text-muted should use your --text-muted-color */}
                <p className="text-muted small mb-0">{contactDetails.university}</p>
                {contactDetails.department && <p className="text-muted small">{contactDetails.department}</p>}
              </div>

              {/* Contact Details Sections */}
              <div className="px-md-3">
                {/* Address Section - Centered */}
                <div className="mb-4 text-center">
                  {/* text-dark should ideally map to --text-color in dark mode */}
                  <h5 className="fw-medium mb-2">Addresse</h5>
                  {/* text-secondary needs to be styled for dark mode in dark.scss or rely on Bootstrap's dark theme variable */}
                  <p className="text-secondary mb-0">{contactDetails.address.street}</p>
                  <p className="text-secondary mb-0">{contactDetails.address.city}</p>
                  <p className="text-secondary mb-0">{contactDetails.address.country}</p>
                </div>
                
                {/* Email and LinkedIn sections are removed as they are not in the new contactDetails */}

              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
